import { useInfiniteQuery } from 'react-query'
import { getRequestMessageInPage2 } from 'services/messages'

export default function useGetRequestMessage() {
    const { data, isLoading, fetchNextPage } = useInfiniteQuery(
        ['get-request-message-in-page-2'],
        ({ pageParam = 'None', queryKey }) =>
            getRequestMessageInPage2(pageParam),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord =
                    allPages[allPages.length - 1]?.last_date || ''
                return lastRecord ? lastRecord : undefined
            },
        }
    )
    return { requestMessage: data, isLoading, fetchNextPage }
}
